import $ from 'jquery'

import 'framework/map_init'
import 'framework/accordion_init'
import 'framework/collection-teaser_init'
import 'framework/slider_init'

import 'scss/digikat_base.scss'

import 'modal/js/modal'
import 'list/js/list'
import 'detail/js/detail'
import 'exhibit/js/exhibit'